import type { AgentToolDescriptor } from "./agentTypes";
import { type ToolResult, wrappedBodyKey } from "./tools";

type Schema = Record<string, unknown>;

export const UNKNOWN_FIELDS = "UNKNOWN_FIELDS";

export const unknownFieldsRefusal = (descriptor: AgentToolDescriptor, args: Record<string, unknown>): ToolResult | null => {
  const params = Object.fromEntries(descriptor.params.map((param) => [param.name, param.schema]));
  const bodyKey = wrappedBodyKey(descriptor.toolName);
  const wrapped = bodyKey ? { [bodyKey]: { properties: params } } : {};
  const topLevel: Schema = { properties: { ...params, ...wrapped } };
  const unknown = unknownPaths(args, topLevel, "");
  if (unknown.length === 0) return null;
  return {
    ok: false,
    deviationCode: UNKNOWN_FIELDS,
    message:
      `Ikke sendt: ${descriptor.toolName} har ikke feltene ${unknown.join(", ")}, så de ville ikke blitt lagret. ` +
      "Bruk bare feltene i verktøyets skjema. Kan ikke verdien settes med noe felt der, si det til brukeren.",
  };
};

const unknownPaths = (value: unknown, schema: Schema, path: string): string[] => {
  if (Array.isArray(value)) {
    const items = schema.items as Schema | undefined;
    return items ? value.flatMap((item, index) => unknownPaths(item, items, `${path}[${index}]`)) : [];
  }
  if (!value || typeof value !== "object") return [];
  const properties = propertiesOf(schema);
  if (!properties) return [];
  return Object.entries(value as Record<string, unknown>).flatMap(([key, child]) => {
    const childPath = path ? `${path}.${key}` : key;
    const childSchema = properties[key];
    return childSchema ? unknownPaths(child, childSchema, childPath) : [childPath];
  });
};

const propertiesOf = (schema: Schema): Record<string, Schema> | null => {
  const variants = [schema, ...((schema.allOf as Schema[] | undefined) ?? [])];
  const merged = Object.assign({}, ...variants.map((variant) => (variant.properties as Record<string, Schema>) ?? {}));
  return Object.keys(merged).length > 0 ? merged : null;
};
